<template>
<div class="productList">
  <Breadcrumb />
  <Banner class="hidden md:block" />

  <ListDigi v-if="$route.params.category === 'digital' && $route.query.digiType" />

  <section v-else>
    <!-- 排序 -->
    <Sort :sort="sort" v-on:updatedSort="updatedSort" />

    <!-- 商品列表 -->
    <div class="mainlist mb-10">
      <div class="flex flex-wrap" v-if="productData">
        <div class="w-1/2 sm:w-1/3 mb-4 px-2 flex-shrink" v-for="(item, index) in productData" :key="index">
          <ProductModule :data="productData[index]" v-on:refreash="refreash" />
        </div>
      </div>

      <div class="loading md:p-1 lg:p-5 flex flex-wrap" v-else>
        <vue-content-loading :width="100" :height="120" class="w-1/2 md:w-1/3" v-for="(item, index) in 9" :key="index">
          <rect cx="30" cy="30" width="65" r="30" height="80" x="15" />
          <rect cx="30" cy="80" r="50" x="10" y="85" rx="3" ry="3" width="75" height="4" />
          <rect x="10" y="95" rx="3" ry="3" width="55" height="4" />
          <rect x="10" y="105" rx="3" ry="3" width="20" height="4" />
        </vue-content-loading>

      </div>
    </div>

    <PaginateComponent :pagination="pagination" v-on:pageChangeHandler="pageChangeHandler" v-if="$route.query.type !== 'plan'" />
  </section>
</div>
</template>
<script>
/* eslint-disable no-unused-expressions */
import PaginateComponent from '@/components/modules/Paginatation'
import Cart from '@/components/modules/addCart'
import axios from 'axios'
import VueContentLoading from 'vue-content-loading'
import Banner from '@/components/product/Banner.vue'
import ProductModule from '@/components/product/ProductModule'
import Breadcrumb from '@/components/product/Breadcrumb'
import Sort from '@/components/product/Sort'
import ListDigi from '@/components/product/ListDigi'
import ga4 from '@/components/modules/ga4'
export default {
  name: 'ProductList',
  metaInfo () {
    return {
      title: this.page_title,
      meta: [
        { vmid: 'title', property: 'og:title', content: this.page_title },
        { vmid: 'url', property: 'og:url', content: 'https://store.liveabc.com' + this.$route.path }
      ]
    }
  },
  data () {
    return {
      productData: null,

      sort: {
        sort: 'published_at',
        sortBy: null
      },

      pageSize: 9,

      pagination: {
        currentPage: 1,
        length: 5
      }
    }
  },
  components: {
    PaginateComponent,
    VueContentLoading,
    Banner,
    ProductModule,
    Breadcrumb,
    Sort,
    ListDigi
  },
  mixins: [
    Cart,
    ga4
  ],
  computed: {
    page_title () {
      let self = this
      switch (self.$route.params.category) {
        case 'recent':
          return '最新優惠'
        case 'magazine':
          return '雜誌館'
        case 'book':
          return '叢書館'
        case 'package':
          return '套書館'
        case 'digital':
          return '數位學習館'
        case 'livepen':
          return '點讀館'
      }
      return ''
    },
    page_category_nema () {
      let self = this
      if (self.$route.params.category === 'magazine' && self.productData && self.productData.length > 0) {
        return self.productData[0].category_name
      } else if (self.$route.params.category === 'book' && self.$route.query.type === 'BOOK' && self.$route.query.category && self.productData && self.productData.length > 0) {
        return self.productData[0].category_name
      } else if (self.$route.params.category === 'book' && self.$route.query.type === 'BOOK,DIGITAL' && self.productData && self.productData.length > 0) {
        return '電腦互動學習軟體專區'
      } else if (self.$route.params.category === 'package' && self.$route.query.type === 'PACKAGE' && self.$route.query.category && self.productData && self.productData.length > 0) {
        return self.productData[0].category_name
      } else if (self.$route.params.category === 'package' && self.$route.query.type === 'ITEM' && self.productData && self.productData.length > 0) {
        return '點讀筆購買'
      } else {
        return ''
      }
    },
    mag_scope_nema () {
      let self = this
      if (self.$route.params.category === 'magazine') {
        if (self.$route.query.type === 'PLAN' && self.$route.query.scope === 'new_magazine_plan') {
          return '雜誌新訂'
        } else if (self.$route.query.type === 'PLAN' && self.$route.query.scope === 'discount_magazine_plan') {
          return '雜誌續訂'
        } else if (self.$route.query.type === 'MAGAZINE,PHYSICAL') {
          return '紙本零售'
        } else if (self.$route.query.type === 'MAGAZINE,DIGITAL') {
          return '軟體零售'
        } else if (self.$route.query.type === 'PLAN' && self.$route.query.scope === 'magazine_plan') {
          return '雜誌訂閱'
        }
        return ''
      }
      return ''
    }
  },
  watch: {
    '$route.params': {
      handler (newVal, oldVal) {
        let self = this
        // 換不同館
        if ((newVal.category !== oldVal.category)) {
          this.pagination.currentPage = 1
          if (this.sort.isPricing) {
            this.sort.isPricing = false
            this.sort.type = 'published_at'
          }
          newVal.category === 'recent' ? self.getSales() : null
        }
      }
    },
    '$route.query': {
      handler (newVal, oldVal) {
        // 換不同分類
        if ((newVal.category !== oldVal.category) || (newVal.type !== oldVal.type) || (newVal.query !== oldVal.query) || (newVal.scope !== oldVal.scope) || (newVal.P !== oldVal.P)) {
          this.pagination.currentPage = 1
          this.getDatas()
        }
      },
      deep: true
    },
    pageSize: {
      handler (newValue, oldValue) {
        let self = this
        if (newValue !== oldValue) {
          self.getDatas()
        }
      }
    }
  },
  created () {
  },
  mounted () {
    this.getDatas()
  },
  methods: {
    getDatas () {
      this.$route.params.category === 'recent' ? this.getSales() : this.getData()
    },
    async getSales () {
      let self = this
      let dataObj = {
        params: {}
      }
      dataObj.params.sort = 'created_at'
      dataObj.params.sortBy = self.sort.sortBy
      let { data } = await axios.get(`/promote_events`, dataObj)

      self.productData = data.data
      self.pagination.length = data.last_page
    },
    async getData () {
      let self = this
      let routerName = self.$route.params.category
      let appierCategory = []

      let dataObj = {
        params: {}
      }
      if (routerName === 'magazine' || routerName === 'package' || routerName === 'book' || routerName === 'digital' || routerName === 'livepen') {
        // 雜誌
        if (self.$route.query.category) {
          dataObj.params.category = self.$route.query.category
        }
        if (self.$route.query.type) {
          dataObj.params.type = self.$route.query.type.toLocaleUpperCase()
        }
        if (self.$route.query.query !== '') {
          dataObj.params.query = self.$route.query.query
        }
        if (self.$route.query.scope !== '') {
          dataObj.params.scope = self.$route.query.scope
        }
      } else if (routerName === 'recent') {
        // 新品
        dataObj.params.scope = 'new_arrival'
      }

      if (self.sort.isPricing) {
        dataObj.params.sort = 'pricing'
        dataObj.params.sortBy = self.sort.sortBy
      } else {
        dataObj.params.sort = 'published_at'
        dataObj.params.sortBy = self.sort.sortBy
      }

      if (self.$route.query.category) {
        dataObj.params.category = self.$route.query.category

        self.$route.query.category === 'package' ? dataObj.params.scope = 'classic_package_series' : null
      }
      if (self.$route.params.category && self.$route.params.category === 'package') {
        dataObj.params.scope = 'classic_package_series'
      }
      if (self.$route.query.P) {
        self.pagination.currentPage = Number(self.$route.query.P)
      }

      let { data } = await axios.get(`/products?page=${self.pagination.currentPage}&pageSize=${self.pageSize}`, dataObj)

      self.productData = data.data
      self.pagination.length = data.last_page

      self.likeCatgeogryCode(appierCategory, data.data)

      // ga4
      self.view_item_list(dataObj, data)
    },
    updatedSort (updatedSort) {
      let self = this

      self.sort.sort = updatedSort.sort
      self.sort.sortBy = updatedSort.sortBy

      self.productData = null
      self.getDatas()
    },
    async pageChangeHandler (pageChangeHandler) {
      let self = this
      self.pagination.currentPage = pageChangeHandler
      await self.$router.push({
        name: 'productsList',
        params: {
          category: self.$route.params.category
        },
        query: {
          type: self.$route.query.type,
          category: self.$route.query.category,
          query: self.$route.query.query,
          scope: self.$route.query.scope,
          P: pageChangeHandler
        }
      })
      self.getData()
    },
    refreash (refreash) {
      let self = this
      self.getDatas()
    }
  }
}
</script>
<style lang="scss">
  .productList {
    .mainlist {
      min-height: 20vh;
    }
  }
</style>
